import React, { useState, useEffect } from "react";
import Board from "react-trello";
import { fetchJson } from "../../lib/Fetching";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import { DateRangePicker } from "react-dates";
import moment from "moment";

export default function Kanban({}) {
  const [data, setData] = useState(null);
  const [focusedInput, setFocusedInput] = useState(null);
  const [dates, setDates] = useState([moment().subtract(4, "days"), moment()]);

  useEffect(() => {
    if (!dates[0] || !dates[1]) {
      return;
    }
    fetchJson("/tracking/kanbans.json", {
      start_date: dates[0].format("YYYY-MM-DD"),
      end_date: dates[1].format("YYYY-MM-DD")
    }).then(json => {
      setData(json);
    });
  }, [dates]);

  const _baseUrl = window.location.protocol + "//" + window.location.host;

  const handleCardClick = cardId => {
    window.open(_baseUrl + "/tracking/item_sessions/" + cardId, "_item_session");
  };

  const handleLaneClick = laneId => {
    window.open(_baseUrl + "/tracking/item_types/" + laneId, "_item_types");
  };

  return (
    <div>
      <div style={{ maxWidth: 400, marginBottom: 10 }}>
        <label>Session created between:</label>
        <DateRangePicker
          startDateId="start_date"
          startDate={dates[0]}
          endDateId="end_date"
          endDate={dates[1]}
          numberOfMonths={1}
          onDatesChange={({ startDate, endDate }) => setDates([startDate, endDate])}
          focusedInput={focusedInput}
          onFocusChange={focusedInput => setFocusedInput(focusedInput)}
          showClearDates={true}
          isOutsideRange={() => false}
          hideKeyboardShortcutsPanel={true}
          displayFormat="DD MMM YYYY"
          minimumNights={0}
        />
      </div>
      {!data && (
        <p>
          <i className="fa fa-spin fa-spinner" />
          &nbsp; Loading...
        </p>
      )}
      {data && (
        <Board
          draggable
          cardStyle={{ maxWidth: 280, minWidth: 270 }}
          laneStyle={{ width: 300, maxHeight: "calc(100vh - 220px)" }}
          style={{
            borderRadius: 10,
            backgroundColor: "rgba(0,0,0,0.0)",
            height: "calc(100vh - 180px)"
          }}
          collapsibleLanes
          laneDraggable
          data={data}
          onCardClick={handleCardClick}
          onLaneClick={handleLaneClick}
        />
      )}
    </div>
  );
}
